module.exports = __webpack_public_path__ + "img/cateCommon-H-l-icon2.d2184088.png";